import React from 'react';
import vertexTools from '../../assets/projectImages/vertexToolsImages/mainPicture/vertexToolsMainImage.png'
import primaxElectronics from '../../assets/projectImages/primaxElectronicsImages/mainPicture/primaxElectronicsMainImage.png';
import dreamsPhotography from '../../assets/projectImages/dreamsPhotographyImages/mainPicture/dreamsPhotographyMainImage.png';
import MyProject from './MyProject';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightToFile } from '@fortawesome/free-solid-svg-icons';


const MyProjects = () => {
    const myProjects = [
        { id: 1, name: "Vertex Tools", img: vertexTools },
        { id: 2, name: "Primax Electronics", img: primaxElectronics },
        { id: 3, name: "Dreams Photography", img: dreamsPhotography }
    ];

    return (
        <section className='mx-2 sm:mx-5 overflow-hidden'>
            <h2 className='text-green-600 text-center text-3xl md:text-4xl Black-Ops-One capitalize pt-10 pb-8' data-aos="flip-down" >Projects</h2>
            <div className='flex flex-col items-center text-center'>
                <div className='w-full grid lg:grid-cols-3 gap-5'>
                    {myProjects.map(myProject => <MyProject key={myProject.id} myProject={myProject}></MyProject>)}
                </div>
            </div>
            <div className='flex justify-center gap-2 mt-16'>
                <a
                    data-aos="fade-down"
                    data-aos-delay="300"
                    target='blank'
                    href='https://github.com/ShahariarRahman/'
                    className='btn btn-sm capitalize w-40 h-9 font-play font-light rounded text-sm  text-green-400 hover:text-white bg-[#00283ac9] hover:bg-green-600 transition duration-150 ease-in-out border-[1px] border-green-900 hover:border-green-600'>
                    <p >See All Projects<FontAwesomeIcon className='ml-2 text-green-600' icon={faArrowRightToFile} /></p>
                </a>
            </div>
        </section>
    );
};

export default MyProjects;